module.exports = __webpack_public_path__ + "img/youtube.349edc9b.svg";